import WEIGHT_UNITS from './weightUnits'

export default {
  [WEIGHT_UNITS.GRAMS]: 'g',
  [WEIGHT_UNITS.OUNCES]: 'oz',
}



// WEBPACK FOOTER //
// ./src/constants/weightUnitAbbreviations.js